import { RecoverPassword } from 'modules/users/components'
import { UserEmail } from 'framework/users'
import { useNotification } from 'hooks'
import type { FC } from 'react'
import { UserService } from 'modules/users/services'
import type { RecoverPasswordRequestProps } from '.'

const RecoverPasswordRequest: FC<RecoverPasswordRequestProps> = ({ hasCodeSended, onCancel, forceChangePassword }) => {
  const { notify } = useNotification()

  async function onSubmit({ email }: { email: UserEmail }) {
    try {
      const userService = new UserService()
      await userService.requestRecoverPassword(email as unknown as UserEmail)

      if (typeof hasCodeSended === 'function') {
        hasCodeSended(email)
      }
    } catch (e) {
      notify({
        title: 'Atenção',
        description: e?.response?.data?.message,
        type: 'danger',
      })
    }
  }

  return <RecoverPassword forceChangePassword={forceChangePassword} onSubmit={onSubmit} onCancel={onCancel} />
}

export default RecoverPasswordRequest
